import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const usePersonalisedPoolSuccessStyle = createUseStyles({
    layout: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'stretch',
        padding: `112px 0`,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['09'],
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 753,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['09'],
        alignItems: 'center',
    },
    btn: {
        display: 'flex',
        alignItems: 'center',
        width: 320,
        justifyContent: 'center',
        gap: 6,
        fontSize: 14,
        '& rect': {
            fill: color.content.inversePrimary,
        },
        '& svg': {
            transform: 'rotate(180deg)',
        },
    },
    arrow: {
        transform: 'rotate(-90deg)',
    },
    icon: {
        width: 56,
        height: 56,
    },
    top: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['04'],
        alignItems: 'center',
        alignSelf: 'stretch',
    },
    bottom: {
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['04'],
        alignItems: 'center',
        alignSelf: 'stretch',
        '& a': {
            borderBottom: `1px solid ${color.border.accent}`,
            color: color.content.accent,
            fontSize: 16,
            marginLeft: 4,
        },
    },
    title: {
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '28px',
        letterSpacing: '-0.72px',
    },
    note: {
        color: color.content.secondary,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.48px',
        textAlign: 'center',
    },
});
